<ng-template #askUpdate="fpModal" fpModal>
    <div class="modal-header">
        <div class="modal-info">
            <span class="modal-title">New Version Available for Landing Page ⚙️</span>
        </div>
    </div>
    <div class="modal-body updateMdl-body">
        <div class="updateMdl-body">
			<div class="updateMdl-pic">
				<img src="/landing/images/update-img.png" alt="Updates Available" title="Updates Available">
			</div>
			<div class="updateMdl-content">
				<div class="updateMdl-title">What's New?</div>
				<!-- Always wrape title and decription in updateMdl-bunch class div -->
				<div class="updateMdl-bunch">
					<div class="updateMdl-subTitle">1. Various Bug Fixes and Improvements.</div>
				</div>
				<div class="updateMdl-bunch">
					<div class="updateMdl-subTitle">2. Security Upgrades.</div>
				</div>
			</div>
		</div>
    </div>
    <div class="modal-footer">
		<button type="button" ngbAutofocus class="btn btnthemeFree" (click)="handleUpdateClick()">{{ 'Click to update' | uppercase }}</button>
    </div>
</ng-template>